import React from 'react'

import type {
  GradientInfoHeaderContentBlock,
  WaveLinkHeaderContentBlock,
} from '@library/api-menu-experience'

import { GradientInfoHeader } from '../GradientInfoHeader'
import { WaveLinkHeaderContainer } from '../LinkHeaderContainer'

type MerchandisingHeaderProps = {
  header?: WaveLinkHeaderContentBlock | GradientInfoHeaderContentBlock | null
}

export const MerchandisingHeader = ({ header }: MerchandisingHeaderProps) => {
  if (!header) {
    return null
  }

  switch (header.type) {
    case 'gradient-info-header':
      return (
        <GradientInfoHeader
          gradientColor={header.gradientColor}
          color={header.color}
          headerImage={header.headerImage}
          image={header.image}
          description={header.description}
        />
      )
    case 'wave-link-header':
      return (
        <WaveLinkHeaderContainer
          backgroundColor={header.backgroundColor}
          color={header.color}
          headerImage={header.headerImage}
          description={header.description}
          link={{
            collectionId: header.categoryId,
            collectionSlug: header.categorySlug ?? '',
          }}
        />
      )
    default:
      return null
  }
}
